/**
 * Google OAuth and Workspace configuration
 */

// Google OAuth configuration
export const GOOGLE_OAUTH_CONFIG = {
  clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  redirectUri: process.env.REACT_APP_GOOGLE_REDIRECT_URI || `${window.location.origin}/auth/callback`,
  scope: [
    'openid',
    'profile',
    'email'
  ].join(' '),
  // For client-side OAuth, use implicit flow
  responseType: 'token id_token',
  includeGrantedScopes: true
};

// Google Workspace group mappings for role assignment
export const GOOGLE_WORKSPACE_GROUPS = {
  ADMIN: 'admin-level@satellitetalent.com',
  TALENT_PARTNER: 'talent-partners@satellitetalent.com'
};

// OAuth endpoints
export const OAUTH_ENDPOINTS = {
  AUTH_URL: 'https://accounts.google.com/o/oauth2/v2/auth',
  TOKEN_URL: 'https://oauth2.googleapis.com/token',
  USER_INFO_URL: 'https://www.googleapis.com/oauth2/v2/userinfo',
  REVOKE_URL: 'https://oauth2.googleapis.com/revoke'
};

// JWT configuration
export const JWT_CONFIG = {
  secret: process.env.REACT_APP_JWT_SECRET,
  expiresIn: '8h', // 8 hour session timeout as per PRD requirements
  issuer: 'satellite-talent-dashboard',
  audience: 'satellite-talent-users'
};

// Session configuration
export const SESSION_CONFIG = {
  storageKey: 'satellite_auth_token',
  refreshThreshold: 3600000, // Refresh token 1 hour before expiry (in milliseconds)
  maxRetries: 3
};

// Google Apps Script Web App URL (existing integration)
export const GOOGLE_APPS_SCRIPT_URL = process.env.REACT_APP_GOOGLE_SCRIPT_URL;

// Validation function for required environment variables
export const validateGoogleConfig = () => {
  const requiredVars = [
    'REACT_APP_GOOGLE_CLIENT_ID',
    'REACT_APP_GOOGLE_SCRIPT_URL'  // Fixed: was REACT_APP_GOOGLE_APPS_SCRIPT_URL
  ];

  const missing = requiredVars.filter(varName => !process.env[varName]);
  
  if (missing.length > 0) {
    console.error('Missing required environment variables:', missing);
    return false;
  }
  
  return true;
};